module.exports = __webpack_public_path__ + "static/media/comment-alt-regular.4158d743.svg";